import { FilterBuilder, type FilterBuilderProps } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import {
  useFiltersOperatorsLabelsTranslations,
  useFiltersOperatorsValuesResolver,
  useFiltersSlidingPresetsLabelsTranslations,
} from "~/hooks/useFiltersOperatorsTranslations"

export type FilterBuilderWrapperProps<T> = Omit<
  FilterBuilderProps<T>,
  | "operatorLabelTranslationMapping"
  | "dateValueLabelResolver"
  | "slidingPresetLabelTranslationMapping"
>

export function FilterBuilderWrapper<
  T extends Partial<Record<string, unknown>>,
>(props: FilterBuilderWrapperProps<T>) {
  const { t } = useTranslation("common")
  const operatorLabelTranslationMapping =
    useFiltersOperatorsLabelsTranslations()

  const slidingPresetLabelTranslationMapping =
    useFiltersSlidingPresetsLabelsTranslations()

  const dateValueLabelResolver = useFiltersOperatorsValuesResolver(
    slidingPresetLabelTranslationMapping
  )

  return (
    <FilterBuilder
      {...props}
      title={props.title ?? t("filter")}
      searchPlaceholder={
        props.searchPlaceholder ?? t("sort.search.placeholder")
      }
      operatorLabelTranslationMapping={operatorLabelTranslationMapping}
      slidingPresetLabelTranslationMapping={
        slidingPresetLabelTranslationMapping
      }
      dateValueLabelResolver={dateValueLabelResolver}
    />
  )
}
